<template>
    <div class="lang">
        <div class="info">
            <div class="full-width"><img src="/resource/img/center-bg.jpg" alt="" class="full-width--bg">
                <h3 class="title01">Wellness Center</h3>
                <h4 class="title03">
                    The term, Wellness combines two concepts together:
                    well-being and fitness.
                    This is the fundamental of a happy life
                    with physical, mental, and social health in harmony.
                    Wellness Health Promotion Center offers accurate
                    and credible health management services
                    as a companion through your healthy and happy life.</h4>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Customized Program</h3>
            <p class="bullet03 depth">We provide customized programs based on individual features of the examinee through one-on-one counseling with coordinator upon personal visit or through a happy-call service upon an internet or telephone
                reservation, respectively.</p>
            <p class="bullet03 depth">We have established a unique program that suits to various individual characteristics, facilitating an each decision-making process.</p>
            <p class="bullet03 depth">We implement a smart system to conduct an on-line medical interview and refer to personal family history, life habits, and uncomfortable symptoms in order for the data to be applied in determining a necessity of
                additional examination and analyzing
                the medical examination result.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Pursuing accurate medical examination with the aid of up-to-date medical facilities and medical staff with rich experience</h3>
            <p class="bullet03 depth">We are staffed with medical team with rich experience exclusively dedicated for the Health Promotion Center and medical personnel consisting of departments’ collaborative professors who can be promptly and
                closely connected with.</p>
            <p class="bullet03 depth">We are equipped with a wide range of different cutting-edge medical devices including CT, MRI, ultrasound, PET, endoscope, etc. to raise the level of accuracy.</p>
            <p class="bullet03 depth">To diagnosis a cancer or severe disease, medical staff and coordinators allocated exclusively for Wellness will immediately and systematically link you to an outpatient treatment.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Providing elegant medical examination experience</h3>
            <p class="bullet03 depth">Experience of a pleasant medical examination course is expected on account of spacious space configuration and comfortable waiting space.</p>
            <p class="bullet03 depth">Waiting space and accommodation for VIPs will be able to upgrade the dignity of premium medical examination.</p>
        </div>
    </div>
</template>
<script>

    export default {
    }

</script>